import { render } from "./OrderSummaryDataFile.vue?vue&type=template&id=6089329c"
import script from "./OrderSummaryDataFile.vue?vue&type=script&lang=js"
export * from "./OrderSummaryDataFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__